import { useEffect } from "react";
import axios from "axios";
import { Toaster } from "sonner";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Threat } from "../components/Threat";
import ScanTool from "../components/ScanTool";
import { HowItWorks } from "../components/HowItWorks";
import { ToolbarPlayground } from "../components/ToolbarPlayground";
import { BigWins } from "../components/BigWins";
import { PricingBrief } from "../components/PricingBrief";
import { FAQ } from "../components/FAQ";
import { Footer } from "../components/Footer";
import { StickyCTA } from "../components/StickyCTA";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClickTracker = () => {
  useEffect(() => {
    const handler = (e) => {
      const el = e.target?.closest?.("[data-testid]");
      if (!el) return;
      axios
        .post(`${API}/track`, { element: el.dataset.testid, path: window.location.pathname })
        .catch(() => {});
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
  return null;
};

const Landing = () => (
  <div className="min-h-screen bg-ink text-slate-100 antialiased">
    <ClickTracker />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Threat />
      <ScanTool />
      <HowItWorks />
      <ToolbarPlayground />
      <BigWins />
      <PricingBrief />
      <FAQ />
    </main>
    <Footer />
    <StickyCTA />
    <Toaster richColors position="top-center" theme="dark" />
  </div>
);

export default Landing;
